import React, { useState, useEffect  }  from "react";
import InputField from "components/fields/InputField";
import Button from "components/button";
import CardItem from "components/card/CardItem";
import { ReactComponent as Logo } from 'assets/svg/intsamis_logo.svg';
import { connect } from "react-redux";
import { loginRequest } from "../../redux/auth/authState";
import { useLocation } from "react-router-dom";
import HomeBanner from "components/banners/HomeBanner";

const SignIn = ({ login, qrUser }) => {
  const [inputs, setInputs] = useState({});
  const [fromKiosk, setFromKiosk] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get('type');
  //const username = searchParams.get('username');

  useEffect(() => {
    if (type === 'kiosk' && qrUser) {
      setFromKiosk(true);
      setInputs(values => ({ ...values, username: qrUser.data.username }));
    }
  }, [type]); 

  const handleChange = (event) => {
    const name = event.target.id;
    const value = event.target.value;
    setInputs(values => ({...values, [name]: value}));
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    try {   
      login({username: inputs.username, password:inputs.password, type: type});
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="m-4 flex flex-col h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
          <HomeBanner/>
          <CardItem 
          extra="w-full md:max-w-[400px] mt-8 border-1 frosted-glass"
          icon={<Logo/>}
          htmlTitle={<h4 className="ml-4 card-title text-2xl md:text-3xl dark:text-theme-200">Sign In</h4>}>
          
          <form onSubmit={handleSubmit} className="frosted-glass rounded-[10px] mt-4 p-4">
            <div className="w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
    
              <InputField
                variant="auth"
                extra="mb-3"
                label="Username*"
                placeholder="username"
                id="username"
                type="text"
                value={inputs.username}
                onChange={handleChange}
              />
    
              <InputField
                variant="auth"
                extra="mb-3"
                label="Password*"
                placeholder="Min. 8 characters"
                id="password"
                type="password"
                value={inputs.password}
                onChange={handleChange}
              />
    
              <div className="mb-4 flex items-center justify-end px-2">
                <a
                  className="text-sm font-medium text-theme-500 hover:text-theme-600 dark:text-white"
                  href=" "
                >
                  Forgot Password?
                </a>
              </div>
              <Button type="submit" extra="w-full">
                Sign In
              </Button>
            </div>
          </form>
          </CardItem>
        </div>
  );
}

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  error: state.auth.error,
  qrUser: state.auth.qrUser,
});

const mapDispatchToProps = (dispatch) => ({
  login: (username, password) => dispatch(loginRequest(username, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);